
export default {
  props: {
    module: Object,
    group: Object
  },

  data () {
    return {
      isReady: false,
      template: {
        images: {
          label: 'Upload Images',
          module: 'upload'
        }
      }
    }
  },

  computed: {
    _group: {
      set (value) {
        this.$emit('update:group', value)
      },

      get () {
        return this.group
      }
    }
  },

  watch: {
    group: {
      handler (val) {
        this.$emit('valid', true)
      },
      deep: true,
      immediate: true
    }
  },

  mounted () {
    if (!this.group) this._group = {}
    this.isReady = true
  }
}
